module.exports = __webpack_public_path__ + "static/media/VR5@2x.ed547006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/VR/VR5@2x.png
// module id = 735
// module chunks = 0